<template lang="pug">
el-dialog#modal-cadastrar-monitoramento-agricola(
    width='500px',
    :visible.sync='show',
    :before-close='fechar',
    :close-on-click-modal='false',
    :close-on-press-escape='false',
    :destroy-on-close='true',
    close='fechar'
)
    span(slot='title')
        h1.font-weight-bold Novo monitoramento agrícola

    el-form.formContainer.w-100.mb-3.p-0(
        :model='dadosMonitoramento',
        :rules='rules',
        ref='formularioAreasMonitoramento'
    )
        el-form-item.my-3(prop='idSafra', label='Ciclo/Ano')
            el-select.w-100(
                v-model='dadosMonitoramento.idSafra',
                placeholder='Selecione',
                value-key='safraAno'
            )
                el-option(
                    v-for='ciclo in cicloAno',
                    :key='"cicloAno" + ciclo.safraAno',
                    :value='ciclo.id',
                    :label='ciclo.safraAno'
                ) {{ ciclo.safraAno }}

        el-form-item.my-3(prop='cultura', label='Cultura esperada')
            el-select.w-100(
                v-model='dadosMonitoramento.cultura',
                placeholder='Selecione',
                :disabled='!dadosMonitoramento.idSafra',
                clearable
            )
                el-option(
                    v-for='cultura in culturas',
                    :key='"cultura" + cultura.id',
                    :value='cultura.id',
                    :label='cultura.nome'
                ) {{ cultura.nome }}

        el-form-item.my-3(
            prop='dataPlantio',
            label='Data de plantio esperada (dd/mm/aaaa)'
        )
            el-date-picker.w-100(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.dataPlantio',
                type='date',
                format='dd/MM/yyyy',
                value-format='yyyy-MM-dd',
                placeholder='',
                clearable
            )

        el-form-item.my-3.inline(
            prop='areaDoPlantio',
            label='Área de plantio esperada (ha)'
        )
            el-input-number(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.areaDoPlantio',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

        el-form-item.my-3.inline(
            prop='produtividade',
            :label='"Produtividade esperada" + formatarUnidadeDeProdutividade()'
        )
            el-input-number(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.produtividade',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

    div(slot='footer')
        .buttons
            el-button(size='mini', @click='fechar')
                | Cancelar
            el-button(
                type='primary',
                size='mini',
                @click='confirmarMonitoramento'
            )
                | Confirmar
</template>

<script>
import UtilsService from '@/services/UtilsService';
export default {
    name: 'ModalCadastrarMonitoramentoAgricola',
    emits: ['cadastrarMonitoramentoAgricola'],
    props: {
        show: {
            type: Boolean,
            default: () => false
        },
        territoriosSelecionados: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            algodao: null,
            rules: {
                idSafra: [
                    {
                        required: true,
                        message: 'Campo obrigatório.',
                        trigger: 'blur'
                    }
                ]
            },
            todasCulturas: [],
            culturas: [],
            cicloAno: [],
            dadosMonitoramento: {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            }
        };
    },

    watch: {
        'dadosMonitoramento.idSafra'(novoId) {
            if (novoId) {
                this.filtrarCulturasPorSafra(novoId);
            }
        }
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
    },

    methods: {
        filtrarCulturasPorSafra(idSafra) {
            const cicloSelecionado = this.cicloAno.find(c => c.id === idSafra);
            if (!cicloSelecionado) return;

            const tipoSafra = cicloSelecionado.safra;

            if (tipoSafra === 'SAFRA') {
                this.culturas = this.todasCulturas.filter(c =>
                    ['Soja', 'Milho'].includes(c.nome)
                );
            } else if (tipoSafra === 'SAFRINHA') {
                this.culturas = this.todasCulturas.filter(c =>
                    ['Soja', 'Milho', 'Algodão'].includes(c.nome)
                );
            } else {
                this.culturas = this.todasCulturas;
            }

            const culturaValida = this.culturas.some(
                c => c.id === this.dadosMonitoramento.cultura
            );
            if (!culturaValida) {
                this.dadosMonitoramento.cultura = null;
            }
        },
        buscarCulturas() {
            UtilsService.getCulturas()
                .then(({ data }) => {
                    const culturasProcessadas = Object.values(data).sort(
                        (a, b) => a.nome.localeCompare(b.nome)
                    );

                    this.todasCulturas = culturasProcessadas;
                    this.culturas = culturasProcessadas;

                    const algodao = culturasProcessadas.find(
                        c => c.nome === 'Algodão'
                    );
                    if (algodao) this.algodao = algodao.id;
                })
                .catch(error => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os dados de culturas.'
                    });
                    throw error;
                });
        },
        filtrarSafrasAtuais(safras) {
            const currentYear = new Date().getFullYear();
            const safrasFiltradas = safras.filter(
                safras => safras.ano >= currentYear
            );
            return safrasFiltradas;
        },

        buscarSafras() {
            UtilsService.getSafrasVigentes().then(response => {
                if (response.status === 200) {
                    this.cicloAno = this.filtrarSafrasAtuais(response.data);
                } else {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar safras'
                    });
                }
            });
        },

        fechar() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        confirmarMonitoramento() {
            this.$refs.formularioAreasMonitoramento.validate(async valid => {
                if (valid) {
                    const areasMonitoramento = [];

                    if (!this.dadosMonitoramento.cultura) {
                        const culturaOutros = this.todasCulturas.find(
                            c => c.codigo === 'OUTROS'
                        );
                        if (culturaOutros) {
                            this.dadosMonitoramento.cultura = culturaOutros.id;
                        } else {
                            this.dadosMonitoramento.cultura = null;
                        }
                    }

                    this.territoriosSelecionados.forEach(
                        ({ idTerritorio, tipoMonitoramento }) => {
                            areasMonitoramento.push({
                                idTerritorio,
                                tipoMonitoramento,
                                ...this.dadosMonitoramento
                            });
                        }
                    );
                    this.$emit(
                        'cadastrarMonitoramentoAgricola',
                        areasMonitoramento
                    );

                    this.fechar();
                }
            });
        },
        clearFields() {
            this.dadosMonitoramento = {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            };
        },
        formatarUnidadeDeProdutividade() {
            return this.dadosMonitoramento.cultura !== null &&
                this.dadosMonitoramento.cultura === this.algodao
                ? ' (@/ha)'
                : ' (sc/ha)';
        }
    }
};
</script>

<style lang="scss">
#modal-cadastrar-monitoramento-agricola {
    border-radius: 5px;
    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }
    .el-dialog__body {
        padding: 0 20px 30px;
        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }
    }
    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
